'use client';

import React, { useMemo } from 'react';

import dynamic from 'next/dynamic';

import type { Coords } from '@/common/types/vip-vendor-contact-us.type';
import type { LatLngTuple } from 'leaflet';

import Button from '@/common/components/button';

const SectionMap = ({
  id,
  center,
  pins,
}: {
  id: string;
  center: LatLngTuple;
  pins?: Coords[];
}) => {
  const Map = useMemo(
    () =>
      dynamic(
        async () => await import('@/common/components/map').then((m) => m.Map),
        {
          ssr: false,
          loading: () => (
            <div className="h-[199px] w-full rounded-lg bg-gray-200" />
          ),
        }
      ),
    []
  );

  return (
    <div className="relative mt-2 h-64 w-full min-h-[200px] rounded-md md:mt-0 md:h-auto md:w-1/2">
      <Map id={id} center={center} pins={pins} zoom={16} hideCurrentLocation />
      <Button
        iconPosition="start"
        type="black"
        href={`geo:${center[0]},${center[1]}`}
        className="absolute bottom-3 right-3 z-[999999] h-fit text-center"
      >
        مسیر یابی
      </Button>
    </div>
  );
};

export default SectionMap;
